// app/components/OfflineQueueSync.client.tsx
// Component to initialize offline queue auto-sync
// Client-only component (uses browser APIs)

import { useEffect } from "react";
import { startAutoSync } from "~/lib/offline/offline-queue.client";

export function OfflineQueueSync() {
  useEffect(() => {
    if (typeof window === "undefined") return;

    // Start auto-sync every 30 seconds
    const cleanup = startAutoSync(30000);

    // Cleanup on unmount
    return cleanup;
  }, []);

  return null; // This component doesn't render anything
}
